import { AppGeneric24Regular, Home24Regular } from '@/components/Icon'
import PATHS from '@/routes/paths'

export const PRIMARY_NAV_ITEMS = [
  { key: 'home', label: 'Home', Icon: Home24Regular, path: PATHS.HOME },
  { key: 'appgen', label: 'AppGen', Icon: AppGeneric24Regular, path: PATHS.APPGEN },
]

export const PRIMARY_NAV_GROUPS = {
  top: ['home', 'appgen'],
  bottom: [],
}
